// @flow

// Libs
import React from 'react'

// Messages
import { FormattedMessage } from 'react-intl'
import messages from 'hfty-datatable-comments/src/messages'

// Constants
import {
  SMALL_SIZE,
  MEDIUM_SIZE,
  LARGE_SIZE,
  SORT_AS_NUMBER,
  SORT_AS_DATE,
  SORT_AS_MIX,
  SORT_AS_BOOLEAN,
} from 'fc-component-datatable'
import {
  ATTR_COMMENT_ID,
  ATTR_CROP,
  ATTR_YIELD_TARGET,
  ATTR_FIELD,
  ATTR_DATE_CREATED,
  ATTR_RECOMMENDED_RATES,
  ATTR_HAS_RECOMMENDED_RATES,
} from './constants'

// Translate util
const translate = (column: Object): React.Element<any> => <FormattedMessage {...messages[column.attr]} />

// Columns config
export default [
  {
    attr: ATTR_COMMENT_ID,
    size: SMALL_SIZE,
    render: translate,
    sortAs: SORT_AS_NUMBER,
  },
  {
    attr: ATTR_CROP,
    size: LARGE_SIZE,
    render: translate,
  },
  {
    attr: ATTR_YIELD_TARGET,
    size: MEDIUM_SIZE,
    render: translate,
    sortAs: SORT_AS_MIX,
  },
  {
    attr: ATTR_FIELD,
    size: LARGE_SIZE,
    render: translate,
  },
  {
    attr: ATTR_DATE_CREATED,
    size: LARGE_SIZE,
    render: translate,
    sortAs: SORT_AS_DATE,
  },
  {
    attr: ATTR_RECOMMENDED_RATES,
    size: SMALL_SIZE,
    render: translate,
    allowFiltering: false,
    sortAs: SORT_AS_BOOLEAN,
    booleanAttr: ATTR_HAS_RECOMMENDED_RATES,
  },
]
